export default "__VITE_ASSET__C7In4be8__"